export default {
  perMeetingServiceNote: '22022019-142905-0018',
  perPersonServiceTitle: '22022019-142905-0019',
  perPersonServiceNote: '22052023-090618-2784',
  perHourServiceNote: '02062020-091149-5037',
  perDayServiceNote: '19052023-083127-3893',
  perItemServiceNote: '19052023-073559-8290',
  serviceNumberOfServings: '14122016-084343-8462',
  servingTime: '18112016-133859-6939',
  people: '18112016-101623-2917',
  addMore: '30062020-131132-6181',
  add: '01082016-104007-5504',
  added: '28102025-085406-0001',
};
